export default __webpack_public_path__ + "static/media/award.14ea6b22.JPG";